/**
 * Global Webpack 5 Chunk Load Retry
 * Patches __webpack_require__.l to retry failed chunk downloads with exponential backoff.
 * Must be imported before any dynamic imports are triggered.
 */
(function () {
  var MAX_RETRIES = 3;
  var BASE_DELAY_MS = 1000;
  var isDev = typeof process !== 'undefined' && process.env && process.env.APP_ENV === 'development';
  var retryState = Object.create(null);

  function log() { if (isDev) console.warn.apply(console, ['[ChunkRetry]'].concat(Array.prototype.slice.call(arguments))); }

  function removeScriptTag(url) {
    var baseUrl = url.split('?')[0];
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length - 1; i >= 0; i--) {
      if (scripts[i].src && scripts[i].src.indexOf(baseUrl) !== -1) {
        scripts[i].parentNode.removeChild(scripts[i]);
        return;
      }
    }
  }

  if (typeof __webpack_require__ === 'undefined' || !__webpack_require__.l) return;

  var originalLoadScript = __webpack_require__.l;
  if (originalLoadScript.__chunkRetryPatched) return;

  __webpack_require__.l = function (url, done, key, chunkId) {
    var wrappedDone = function (event) {
      if (!event || event.type === 'load') {
        delete retryState[url];
        done(event);
        return;
      }

      var state = retryState[url] || (retryState[url] = { attempts: 0, inFlight: false });

      if (state.inFlight) return;

      state.attempts++;

      if (state.attempts <= MAX_RETRIES) {
        var delay = BASE_DELAY_MS * Math.pow(2, state.attempts - 1);
        state.inFlight = true;
        log('Retry ' + state.attempts + '/' + MAX_RETRIES + ' for', url, 'in ' + delay + 'ms');

        removeScriptTag(url);

        setTimeout(function () {
          state.inFlight = false;
          var sep = url.indexOf('?') !== -1 ? '&' : '?';
          originalLoadScript(url + sep + '__retry=' + state.attempts + '&__t=' + Date.now(), wrappedDone, key, chunkId);
        }, delay);
      } else {
        log('All retries exhausted for', url);
        delete retryState[url];
        done(event);
      }
    };

    originalLoadScript(url, wrappedDone, key, chunkId);
  };

  __webpack_require__.l.__chunkRetryPatched = true;
})();
